import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { useForm } from 'react-hook-form'
import { DeleteWishlist } from '../DeleteWishlist'
import { Wishlist, WishlistItemUpdateInput } from '@pylot-data/pylotschema'
import { WishlistVisibilityEnum } from '@pylot-data/enums/WishlistVisibilityEnum'
import { WishlistItems, WishlistCount } from '../WishlistItems'
import { useWishlistManager } from '../Hooks/useWishlistManager'
import { WishlistToolbar, AddProductsToCart } from '../WishlistToolbar'
import { UpdateWishlist } from '../CreateWishlist'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import { Lock } from 'react-feather'
import s from '@pagestyles/Wishlist.module.scss'

export type Props = {
    wishlist: Wishlist
}

export const WishlistContent: FC<Props> = ({ wishlist }) => {
    const { t } = useTranslation(['wishlist'])
    const {
        register,
        getValues,
        unregister,
        reset,
        formState: { errors }
    } = useForm<Array<WishlistItemUpdateInput>>({ mode: 'onChange' })
    const [showEditForm, setShowEditForm] = useState(false)

    const wishlistManager = useWishlistManager()
    const { resetSelected, wishlistState } = wishlistManager
    const hasWishlistItem = wishlist?.items_count! > 0
    const config = useStoreConfig()

    //Reset selected items on page transition
    useEffect(() => {
        reset()
        unregister()
        resetSelected()
    }, [wishlist?.id])

    if (!wishlist) return null

    if (showEditForm) {
        return (
            <UpdateWishlist
                wishlist={wishlist}
                setShowEditForm={setShowEditForm}
            />
        )
    }

    return (
        <div>
            <div className={s['wishlist-action-grid']}>
                <WishlistToolbar
                    wishlist={wishlist}
                    wishlistManager={wishlistManager}
                    setShowEditForm={setShowEditForm}
                />
                {/* <UpdateWishlist wishlist={wishlist} /> */}
            </div>
            <WishlistItems
                wishlist={wishlist}
                wishlistManager={wishlistManager}
                register={register}
                getValues={getValues}
                errors={errors}
            />
            <div className={s['wishlist-action-bottom']}>
                {hasWishlistItem && (
                    <AddProductsToCart
                        wishlist={wishlist}
                        getValues={getValues}
                        buttonLabel={t('wishlist|Add All to Cart')}
                        wishlistState={wishlistState}
                        resetSelected={resetSelected}
                        addSelectedButtonActive
                    />
                )}
            </div>
        </div>
    )
}
